import { CircleCheck, RefreshCw, SquarePen, Upload } from "lucide-react";
import { Link } from "react-router-dom";

import { AccordionContent, AccordionItem } from "components/ui/accordion";
import { Button } from "components/ui/button";
import TaskInfo from "pages/CaseDetail/components/Tasks/TaskInfo";
import TaskSummary from "pages/CaseDetail/components/Tasks/TaskSummary";
import { TaskHandlers } from "pages/CaseDetail/components/Tasks/types";
import { TaskAction, taskAction } from "pages/CaseDetail/taskKinds";
import { CaseTask } from "pages/CaseDetail/types";

interface TaskItemProps extends TaskHandlers {
  task: CaseTask;
}

const TaskItem = ({
  task,
  canReopen,
  onReopen,
  onConsent,
  onUpload,
}: TaskItemProps) => {
  const renderAction = (action?: TaskAction) => {
    switch (action?.type) {
      case "upload":
        return (
          <Button
            variant="outline"
            size="sm"
            onClick={() => onUpload(task, action)}
          >
            <Upload />
            Upload document
          </Button>
        );
      case "form":
        return (
          <Button variant="outline" asChild size="sm">
            <Link to={action.to}>
              <SquarePen />
              Complete form
            </Link>
          </Button>
        );
      case "resubmit":
        return (
          canReopen && (
            <Button variant="outline" size="sm" onClick={onReopen}>
              <RefreshCw />
              Re-request application
            </Button>
          )
        );
      case "consent":
        return (
          <Button size="sm" onClick={() => onConsent(task, action)}>
            <CircleCheck />
            {action.label}
          </Button>
        );
      default:
        return null;
    }
  };

  const action = renderAction(taskAction(task));

  return (
    <AccordionItem value={task.uuid} className="border-b-0">
      <div className="flex flex-col gap-3 px-6 py-4 sm:flex-row sm:items-center">
        <TaskSummary task={task} />
        {action && (
          <div className="shrink-0 pl-[3.25rem] sm:pl-0">{action}</div>
        )}
      </div>
      <AccordionContent className="px-6 sm:pl-[4.75rem]">
        <TaskInfo task={task} />
      </AccordionContent>
    </AccordionItem>
  );
};

export default TaskItem;
